import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';
import CopyLink from '../builder/CopyLink.js';
import { ProfileModule } from '../ui_items/Module.js';
import ActivatePromoButton from './elements/ActivatePromoButton.js';

import ProfileMainMenu from './ProfileMainMenu.js';
import IntegrationsMainMenu from './IntegrationsMainMenu.js';
import StatsMainMenu from './StatsMainMenu.js';
import BuzzMainMenu from './BuzzMainMenu.js';
import SecurityMainMenu from './SecurityMainMenu.js';
import { useOwner } from '../context/context.js';
import MailsMainMenu from './MailsMainMenu.js';
import ClassicPromoTag from './ClassicPromoTag.js';
import { agent_roles } from '../account/bootstrap.js';
import OldPromoTag from './OldPromoTag.js';
import ButtonCollection from '../builder/ButtonCollection.js';

const ROLE_ADMIN = 1;

const PROMO_ROLE_ADMIN = 'administrator';
const PROMO_ROLE_EDITOR = 'editor';
const PROMO_ROLE_ANALYST = 'analyst';
const PROMO_ROLE_DESIGNER = 'designer';

const MainMenuWrapper = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;
	
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const menu = props?.menu ?? 'profile';

	const agent_promotion_role = props?.agent_promotion_role ?? ROLE_ADMIN;
	const role = props?.role ?? PROMO_ROLE_ADMIN;

	const is_analyst = (role == PROMO_ROLE_ANALYST || agent_promotion_role == agent_roles.ROLE_ANALYST.id) ? true : false;
	const is_designer = (role == PROMO_ROLE_DESIGNER || agent_promotion_role == agent_roles.ROLE_DESIGNER.id) ? true : false;

	const status = owner?.status ?? 'draft';

	const creation_date = EPDateFormat(promotion.created, 'L');
	const activation_date = EPDateFormat(promotion.pp_payment_date, 'L');
	const agent = owner?.agent?.Agent ?? false;
	const creator = owner?.creator?.Agent ?? false;
	const agent_activator = owner?.agent_activator ?? false;
	const from_corporate = promotion?.from_corporate ?? false;
	const template_deleted = promotion?.template_deleted ?? false;

	const testChange = (test_mode) => {
		owner.dispatch({type:"TOGGLE_TEST",test_mode});
	};

	let creator_name;
	if(creator !== false && creator.id != agent.id) {
		creator_name = <FormattedMessage
			id="Created by {name}, on {date}"
			values={{
				name:<span><strong>{`${creator.name} ${creator.lastname}`}</strong> (#<CopyLink copy_link={creator.id}>{creator.id}</CopyLink>)</span>,
				date:creation_date,
			}}
		/>;
	} else {
		creator_name = <FormattedMessage
			id="Created by {name}, on {date}"
			values={{
				name:<span><strong>{i18n("***you")}</strong></span>,
				date:creation_date,
			}}
		/>;
	}

	let activator_name;
	if(status != 'draft') {
		if(agent_activator !== false && promotion.payer_fbuid != agent.id) {
			activator_name = <FormattedMessage
				id="Activated by {name}, on {date}"
				values={{
					name:<span><strong>{agent_activator[promotion.payer_fbuid]}</strong> (#<CopyLink copy_link={promotion.payer_fbuid}>{promotion.payer_fbuid}</CopyLink>)</span>,
					date:activation_date,
				}}
			/>;
		} else {
			activator_name = <FormattedMessage
				id="Activated on {date}"
				values={{
					date:activation_date,
				}}
			/>;
		}
	}

	return (
		<>
			<ProfileModule _class={{other:'actions_menu', padding:false}}>
				{(status == 'draft' && !is_analyst && !is_designer && (menu == 'profile' && props.selected == 'profile')) && (
					<ActivatePromoButton
						onTestChange={testChange}
						promotion={{ Promotion:promotion }}
						status={status}
						is_agent_admin={owner?.is_agent_admin ?? true}
						has_media={props?.has_media ?? false}
						organizer_id={owner?.organizer_id ?? false}
						has_available_subscription={props?.has_available_subscription ?? false}
						current_active={props?.current_active ?? 0}
						agent_roles={agent.roles}
						account_id={owner?.account?.id ?? false}
					/>
				)}

				{(menu == 'profile') && (
					<ProfileMainMenu {...props} />
				)}

				{(menu == 'integrations') && (
					<IntegrationsMainMenu {...props} />
				)}

				{(menu == 'security') && (
					<SecurityMainMenu {...props} />
				)}

				{(menu == 'stats') && (
					<StatsMainMenu {...props} />
				)}

				{(menu == 'buzz') && (
					<BuzzMainMenu {...props} />
				)}

				{(menu == 'emails') && (
					<MailsMainMenu {...props} />
				)}

				<div class="last_modified gui_only_wide_screen">
					{creator_name}

					{(from_corporate && !template_deleted) && (
						<FormattedMessage
							id="Created from a {link}"
							values={{
								link:<ActionLink _href={`${window.panel_url}agents/templates#view/${from_corporate}`} autotranslate={false}>{i18n("template", 'lowercase')}</ActionLink>,
							}}
						/>
					)}

					{(from_corporate && template_deleted) && (
						<span>{i18n("Created from a [deleted] template")}</span>
					)}

					{activator_name}

					<ButtonCollection>
						<ClassicPromoTag />

						<OldPromoTag />
					</ButtonCollection>
				</div>
			</ProfileModule>
		</>
	)
}

export default injectIntl(MainMenuWrapper);